// Use $ instead of jQuery without replacing global $
(function ($) {

  function search_result() {
    var body_attr1;
    setTimeout(function () {
      body_attr1 = $('body').attr('data-region');

      // Show Page if Geo location is different
      $('.search-result .wrapper .content-outer .content-wrap').removeClass('New');

      $('.search-result .wrapper .content-outer').find('.content-wrap').each(function () {

        if ($(this).hasClass('Australia') && (body_attr1 === 'australia') || $(this).hasClass('all')) {
          $(this).addClass("active");
          $(this).css({"display": "block"});

        } else if ($(this).hasClass('Zealand') && (body_attr1 == 'new_zealand') || $(this).hasClass('all')) {
          $(this).addClass("active");
          $(this).css({"display": "block"});

        } else if ($(this).hasClass('India') && (body_attr1 == 'in') || $(this).hasClass('all')) {
          $(this).addClass("active");
          $(this).css({"display": "block"});

        } else if ($(this).hasClass('Africa') && (body_attr1 == 'africa') || $(this).hasClass('all')) {
          $(this).addClass("active");
          $(this).css({"display": "block"});

        }else if ($(this).hasClass('Mexico') && (body_attr1 == 'mexico') || $(this).hasClass('all')) {
          $(this).addClass("active");
          $(this).css({"display": "block"});

        } else if ($(this).hasClass('China') && (body_attr1 == 'china') || $(this).hasClass('all')) {
          $(this).addClass("active");
          $(this).css({"display": "block"});

        } else if ($(this).hasClass('ExcludeChina') && (body_attr1 != 'china') || $(this).hasClass('all')) {
          $(this).addClass("active");
          $(this).css({"display": "block"});

        } else {
          $(this).remove();
          $(this).addClass('Inactive');
        }
      });
    });
  }


  function search_tracking() {
    if ($('.search-result').length > 0) {
      // google analytics event tracking for search results
      var search_keywords = $('.search-result #views-exposed-form-search-block-1 .form-text').val();
      var result_count = $('body .search-result .wrapper .content-outer .content-wrap').length;
      ga('send', 'event', 'search', 'results', search_keywords, result_count);
      $('body .search-result #views-exposed-form-search-block-1 .form-submit').trigger('click');
    }
  }


  $(document).ajaxSuccess(function () {
    search_result();
    $('.search-result .pager').css({"display": "block"});
    setTimeout(function () {
      var count = $('.search-result .wrapper .content-outer .content-wrap').length;
      if (count > 0) {
        $('.no-result').remove();
      } else {
        if ($('.search-result .no-result').length > 0) {

        } else {
          $('.search-result .wrapper .content-outer').append("<section class='no-result text-center p-4'><h3>Your search yielded no results. </h3><h3>Are you looking for a specific product? Try our Product Finder, <a href='/node/5'>click here</a>.</h3></section>");
        }
      }

      $('#views-exposed-form-search-block-1 .form-actions').append('<div class="we-button"></div>');
    }, 500);

  });

  $(window).on('load', function () {
    var f = 0;
    // $("body .search-result .wrapper .content-outer .content-wrap").unwrap();
    search_tracking();
    setTimeout(function () {
      $('.search-result .form-submit').on('click', function () {
        setTimeout(function () {
          search_tracking();
        }, 500);
      });
    }, 1500);
  });

  // Search click

  function search_taxonomy() {
    var search_val = $('#views-exposed-form-search-block-1 .form-text').val();
    $('.search-result .search_taxonomy #views-exposed-form-search-taxonomy-block-1 .form-item-combine input').val(search_val);
    $('.search-result .search_taxonomy #views-exposed-form-search-taxonomy-block-1 .form-submit').trigger('click');

  }

  $(document).on('click','#views-exposed-form-search-block-1 .we-button',function (e) {
    e.stopPropagation();
    $('#views-exposed-form-search-block-1 .form-submit').trigger('click');
    search_taxonomy();
  });

  $(document).on("keyup", function(event) {
    // Number 13 is the "Enter" key on the keyboard
    if (event.keyCode === 13) {
      if($(".search-result").length > 0) {
        event.preventDefault();
        $('#views-exposed-form-search-block-1 .form-submit').trigger('click');
        search_taxonomy();
      }
    }
  });


})(jQuery);